import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Responsive from '../assets/config/Responsive'
import Colors from '../assets/styles/Colors'
import CustomLink from './CustomLink'

const ProgressBar: React.FC<{
  totalCount: number
  filledCount: number
  stepNumber: string | number
  nextOnClick?: () => void
  prevOnClick?: () => void
  disableNext?: boolean
  disablePrev?: boolean
  nextButton?: boolean
  prevButton?: boolean
}> = ({
  totalCount,
  filledCount,
  stepNumber,
  nextOnClick,
  prevOnClick,
  disableNext = false,
  disablePrev = false,
  nextButton = true,
  prevButton = true,
}) => {
  //
  const StatusLineCount = (filledCount / totalCount) * 100
  //
  const { t } = useTranslation()
  //
  return (
    <Wrapper>
      <LineBackground>
        <StatusLine style={{ width: StatusLineCount + '%' }} />
      </LineBackground>
      <Content>
        <Left>
          {} {t('step') + ' ' + stepNumber}
        </Left>
        <Center>
          <div className="d-flex justify-content-center align-items-center">
            {prevButton && (
              <CustomLink
                onClick={prevOnClick}
                size={'medium'}
                leftLineIcon={true}
                text={`${t('back')}`}
                disabled={disablePrev ? true : false}
              />
            )}

            {nextButton && prevButton && <VerticalLine />}

            {nextButton && (
              <CustomLink
                onClick={nextOnClick}
                size={'medium'}
                rightLineIcon={true}
                text={`${t('next')}`}
                disabled={disableNext ? true : false}
              />
            )}
          </div>
        </Center>
        <Right>
          <PassedCount>
            {filledCount <= 9 ? 0 : null}
            {filledCount}{' '}
          </PassedCount>
          <TotalCount>
            / {totalCount <= 9 ? 0 : null}
            {totalCount}
          </TotalCount>
        </Right>
      </Content>
    </Wrapper>
  )
}
//
//
// styles
const VerticalLine = styled.div`
  width: 2px;
  background-color: ${Colors.secondaryGrey};
  height: 24px;
  margin: 0px 20px;
`
const TotalCount = styled.span`
  font-size: 14px;
  color: ${Colors.primaryGrey};

  ${Responsive.mobile} {
    font-size: 12px;
  }
`
const PassedCount = styled.span`
  font-size: 18px;
  color: ${Colors.primaryBlack};

  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const LineBackground = styled.div`
  position: absolute;
  top: -4px;
  left: 0px;
  height: 4px;
  width: 100%;
  background-color: ${Colors.secondaryGrey};
  border-radius: 48px;
  margin-bottom: -3px;
  transition: all 300ms ease-in;
`
const StatusLine = styled.div`
  height: inherit;
  border-radius: inherit;
  background-color: ${Colors.primaryRed};
  width: 40vw;
  transition: all 300ms ease-in;
`
const Right = styled.div`
  ${Responsive.mobile} {
    display: none;
  }
`
const Center = styled.div``
const Left = styled.div`
  font-size: 14px;
  width: 60px;
  color: ${Colors.primaryGrey};
  ${Responsive.mobile} {
    display: none;
  }
`
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  padding-left: 100px;
  padding-right: 100px;

  ${Responsive.tablet} {
    padding-left: 50px;
    padding-right: 50px;
  }
  ${Responsive.mobile} {
    padding-left: 25px;
    padding-right: 25px;
    justify-content: center;
  }
`
const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 72px;
  background-color: ${Colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  /* user-select: none;
    pointer-events: none; */
  z-index: 2;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;

  ${Responsive.tablet} {
    padding-left: 50px;
    padding-right: 50px;
    height: 48px;
  }
  ${Responsive.mobile} {
    padding-left: 25px;
    padding-right: 25px;
    height: 48px;
  }
`

export default ProgressBar
